import PropTypes from 'prop-types';

export const getLabel = (conditionalLabelOn, values, label, name) =>
  conditionalLabelOn ? label(values[conditionalLabelOn]) : label || name;

export const convertDateValue = (startDateString, endDateString) => {
  const startDateNoYear = startDateString && startDateString.split(',')[0];
  const resolveEndDate = endDateString ? ` - ${endDateString}` : '';
  const inputValue = startDateNoYear ? `${startDateNoYear}${resolveEndDate}` : '';
  return inputValue;
};

export const getSelectedStatus = (options, value) =>
  options.filter(({ value: fieldValue }) => value.includes(fieldValue)).map((option) => option.label);

export const fieldsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    checkin: PropTypes.string,
    checkout: PropTypes.string,
    radios: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ),
    graphql: PropTypes.shape({}),
    characterLimit: PropTypes.number,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ),
    inputProps: PropTypes.shape({})
  })
);
